<script>
    export let img_url;
    export let button_title;
    export let button_link = "";
    export let button_event = "";


	function doEventClick(event_name, event_location){


        if(event_location !== undefined){
			console.log(`sending (with redirect): ${event_name}`);
            window.dataLayer.push({
                'event': event_name,
                'eventCallback': ()=>{window.location.href = event_location;}
            });
        }else{
			console.log(`sending (without redirect): ${event_name}`);
            window.dataLayer.push({
                'event': event_name
            });
        }

        // gtag('event',event_name);
        // gtag('event', event_name, { 'debug_mode':true });
        // gtag('click',event_name);
        // gtag('event', 'Convert', event_name);
		// gtag('event','button_click', {
		// 	'event_name': event_name
		// });

        // setTimeout(()=>{
        //     if(event_location !== undefined){
        //         window.location.href=event_location;			 
        //     }
        // }, 1000);
    }

</script>

<div class="callout-container">
    <div class="callout-icon-container"><img src="{img_url}" alt="icon"></div>
    <div class="callout-copy-container"><slot/></div>
    <div class="callout-button-container">
        <button on:click={()=>{
            if(button_link !== ""){
                if(button_event !== ""){
                    doEventClick(button_event, button_link);
                }else{
                    window.location.href=button_link;
                }
            }            
        }} class="red-button">{button_title}</button>
    </div>
</div>


<style>

.callout-container {
    background-color: var(--bg_white);
    border-radius: 5px;
    width: 320px;
    height: 360px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 60px 20px;
    -webkit-box-shadow: 5px 5px 15px 5px rgba(0,0,0,0.14); 
    box-shadow: 5px 5px 15px 5px rgba(0,0,0,0.14);
}
.callout-icon-container {
    width: 40px;
    padding-bottom: 20px;
    position: relative;
    isolation: isolate;
}
/* .callout-icon-container::before {
    content: ' ';
    position: absolute;
    background-color: var(--bg_gray);
    width: 140px;
    height: 140px;
    border-radius: 50%;
    top: 0%;
    left: 50%;
    transform: translate(-50%, 0%);
    z-index: -1;
} */
.callout-icon-container img {
    width: 100%;
}
.callout-copy-container {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    font-size: 1.25em;
    line-height: 1.5em;
}
.callout-button-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.callout-button-container button {
    margin-top: 30px !important;
}
@media (max-device-width: 1024px), (max-width: 1023px) {
    .callout-container {
        width: 100%;
        box-shadow: none;
    }
    .callout-copy-container {
        font-size: 1.5em;
		line-height: 1.75em;
    }
}

</style>